exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Item___2n2qv:not([hidden]) {\n  display: flex;\n}\n\n.Name___3LSJX {\n  color: var(--color-attribute-name-not-editable);\n  flex: 0 0 auto;\n  cursor: default;\n}\n\n.EditableName___2TyRo {\n  color: var(--color-attribute-name);\n  flex: 0 0 auto;\n  cursor: default;\n}\n\n.AfterName___1HlGw {\n  color: var(--color-text);\n  margin-right: 0.5rem;\n}\n\n.Value___7p123 {\n  color: var(--color-attribute-value);\n  white-space: pre;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: default;\n  flex: 1;\n}\n\n.Link___35OsV {\n  color: var(--color-link);\n  white-space: pre;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1;\n  cursor: pointer;\n  border-radius: 0.125rem;\n  padding: 0px 2px;\n}\n\n.Link___35OsV:hover {\n  background-color: var(--color-background-hover);\n}\n\n\n.ExpandCollapseToggleSpacer___3KNWO {\n  flex: 0 0 1rem;\n  width: 1rem;\n}\n\n.DeleteArrayItemButton___1R-pd {\n  padding: 0;\n  margin-right: 0.125rem;\n}\n\n.HookName___1ZjVf {\n  color: var(--color-component-name);\n}", ""]);

// exports
exports.locals = {
	"Item": "Item___2n2qv",
	"Name": "Name___3LSJX",
	"EditableName": "EditableName___2TyRo",
	"AfterName": "AfterName___1HlGw",
	"Value": "Value___7p123",
	"Link": "Link___35OsV",
	"ExpandCollapseToggleSpacer": "ExpandCollapseToggleSpacer___3KNWO",
	"DeleteArrayItemButton": "DeleteArrayItemButton___1R-pd",
	"HookName": "HookName___1ZjVf"
};